// extracted by mini-css-extract-plugin
module.exports = {"searchesList":"DashboardSyncModal_searchesList___98F9","modalBody":"DashboardSyncModal_modalBody__2-bp7"};